import { render, staticRenderFns } from "./partner-bankCard.vue?vue&type=template&id=01119b31"
import script from "./partner-bankCard.vue?vue&type=script&lang=js"
export * from "./partner-bankCard.vue?vue&type=script&lang=js"
import style0 from "./partner-bankCard.vue?vue&type=style&index=0&id=01119b31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports